import React from 'react'
import footerStyles from './styles.module.scss'

const Footer = ({ url, alt, img }) => {
  return (
    <div className={footerStyles.imageDiv}>
      <a href={url} target="_blank">
        <img src={img} alt={alt} height="50px" width="50px" />
      </a>
    </div>
  )
}

export default Footer
